const TABS = {
  HOME: 'home',
  REMAINING: 'remaining',
  COMPLETED: 'completed'
};
export default TABS;
